import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Mobile } from '../shapes';


const MobileSvg = (props) => (
  <g>
    <IconBounds />
    <Mobile {...props} />
  </g>
);

MobileSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

MobileSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default MobileSvg;
